import SecurityChallenge from './SecurityChallenge';

export default SecurityChallenge;
